export const FETCH_STONE_QUALITY_REQUEST = 'FETCH_STONE_QUALITY_REQUEST';
export const FETCH_STONE_QUALITY_SUCCESS = 'FETCH_STONE_QUALITY_SUCCESS';
export const FETCH_STONE_QUALITY_FAILURE = 'FETCH_STONE_QUALITY_FAILURE';

export const ADD_STONE_QUALITY_REQUEST = 'ADD_STONE_QUALITY_REQUEST';
export const ADD_STONE_QUALITY_SUCCESS = 'ADD_STONE_QUALITY_SUCCESS';
export const ADD_STONE_QUALITY_FAILURE = 'ADD_STONE_QUALITY_FAILURE';

export const UPDATE_STONE_QUALITY_REQUEST = 'UPDATE_STONE_QUALITY_REQUEST';
export const UPDATE_STONE_QUALITY_SUCCESS = 'UPDATE_STONE_QUALITY_SUCCESS';
export const UPDATE_STONE_QUALITY_FAILURE = 'UPDATE_STONE_QUALITY_FAILURE';

export const DELETE_STONE_QUALITY_REQUEST = 'DELETE_STONE_QUALITY_REQUEST';
export const DELETE_STONE_QUALITY_SUCCESS = 'DELETE_STONE_QUALITY_SUCCESS';
export const DELETE_STONE_QUALITY_FAILURE = 'DELETE_STONE_QUALITY_FAILURE';

export const STONE_QUALITY_FORM_ERROR = 'STONE_QUALITY_FORM_ERROR';
export const STONE_QUALITY_FORM_SUCCESS = 'STONE_QUALITY_FORM_SUCCESS';
export const SET_STONE_QUALITY_EDIT = 'SET_STONE_QUALITY_EDIT';
export const CLEAR_STONE_QUALITY_EDIT = 'CLEAR_STONE_QUALITY_EDIT'; 